export const KeyCode = {
    BACKSPACE: 'Backspace',
    ENTER: 'Enter',
    TAB: 'Tab',
    // https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values#whitespace_keys
    SPACEBAR: ' ',
    SPACEBAR_OLD: 'Spacebar',
    ESCAPE: 'Escape',
    ARROW_UP: 'ArrowUp',
    ARROW_DOWN: 'ArrowDown',
    ARROW_LEFT: 'ArrowLeft',
    ARROW_RIGHT: 'ArrowRight',

    SHIFT: 'Shift',

    HOME: 'Home',
    END: 'End',
};
